import type { ComponentStyleConfig } from "@chakra-ui/react";

export const buttonStyle: ComponentStyleConfig = {
  sizes: {
    md: {
      h: "auto",
      py: "2",
      fontSize: "18px",
      paddingX: 6,
    },
  },
  variants: {
    solid: {
      borderRadius: "50px",
      fontSize: "16px",
      fontWeight: "400",
      bg: "primary",
      color: "white",
      _hover: {
        bg: "primary",
        _disabled: {
          bg: "primary",
        },
      },
      _active: {
        bg: "primary",
      },
    },
  },
};
